module.exports = __webpack_public_path__ + "img/mobility_banner.27ef679c.png";